import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    careTagsList: 'mt-10 !border-none group-[.shadow-header]:pt-0',
    gammaSeoBlock: 'container my-10 md:my-15',
    filters:
      'container mt-4 flex items-center justify-between py-1 group-[.shadow-header]:pb-3 max-md:group-[.shadow-header]:mt-1 md:py-2 lg:mt-0',
    filtersPanel: 'mt-12',
    sortPanel: '',
    productWrapper: 'flex flex-col gap-[40px]',
    pagination: 'flex-center container my-12 flex',
    notFound:
      'container mt-15 flex flex-col gap-24 text-base leading-[1.2] font-normal tracking-[.5px] sm:text-lg lg:pl-15.5',
    sortSelect: 'max-w-46.5 md:max-w-59',
    bottomSeoBlock: 'container mt-16 md:mt-30'
  },
  variants: {
    color: {
      primary: 'text-text-main'
    },
    theme: {
      default: {},
      predator: {
        notFound: 'text-white',
        bottomSeoBlock: 'text-white'
      }
    }
  },
  defaultVariants: {
    color: 'primary',
    theme: 'default'
  }
});
